import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import '../assets/scss/exercise-library.scss';

const ExerciseLibraryNav = () => {

  const scrollPage = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="col-right-actions-container">
      <div className="exercise-actions-container">
        <div className="exercise-actions-wrapper">
          action buttons
        </div>
        <div className="exercise-actions-wrapper">
          page sorting
        </div>
        <div className="exercise-actions-wrapper">
          <Link onClick={scrollPage} className="navbar-btn" to='#'>
            <div className="btn-label">my exercises</div>
          </Link>
          <div className="navbar-btn-divider">|</div>
          <Link onClick={scrollPage} className="navbar-btn" to='#'>
            <div className="btn-label">fiterr library</div>
          </Link>
          <div className="navbar-btn-divider">|</div>
          <Link onClick={scrollPage} className="navbar-btn" to='#'>
            <div className="btn-label">show all</div>
          </Link>
          <div className="navbar-btn-divider">|</div>
          <Link onClick={scrollPage} className="navbar-btn" to='#'>
            <div className="btn-label">archived</div>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default withRouter(ExerciseLibraryNav);